import { Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { ToolTipButton } from "nsitools-react";
import * as React from "react";

import { ICustomButtonProps } from "./ICustomButtonProps";

interface IEmailProps extends Omit<ICustomButtonProps, "onClick"> {
  email: string;
  text?: string;
}

export const EmailButton: React.FunctionComponent<IEmailProps> = ({
  minimal = true,
  email,
  loading,
  disabled,
  text,
  intent = Intent.NONE,
}) => {
  const onClickMail = React.useCallback(() => {
    const el = document.createElement("a");
    el.setAttribute("href", `mailto:${email}`);
    el.click();
  }, [email]);

  return email ? (
    <ToolTipButton
      tooltip={email}
      intent={intent}
      disabled={disabled}
      icon={IconNames.ENVELOPE}
      minimal={minimal}
      loading={loading}
      onClick={onClickMail}
      text={text ? text : email}
    />
  ) : (
    <></>
  );
};
